import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "row-block" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "row-block" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "default-form" }
const _hoisted_10 = { class: "input-row" }
const _hoisted_11 = { class: "input-wr" }
const _hoisted_12 = { class: "file-label" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "input-row" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "row-block" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "row-block" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "default-form" }
const _hoisted_23 = { class: "input-row" }
const _hoisted_24 = { class: "input-wr" }
const _hoisted_25 = { class: "file-label" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "input-row" }
const _hoisted_28 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "block-title" }, "Example xlsx Lots Template Settings", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("a", {
            class: _normalizeClass(["button default primary", { disabled: !$setup.templateDownloadLink }]),
            href: $setup.templateDownloadLink,
            target: "_blank"
          }, "Download Lots Template", 10, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "button default delete",
            onClick: $setup.deleteTemplate,
            disabled: !$setup.templateDownloadLink
          }, "Delete Lots Template", 8, _hoisted_7)
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("form", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, [
                _cache[4] || (_cache[4] = _createTextVNode("Select New xlsx Lots Template", -1)),
                _createElementVNode("input", {
                  onChange: _cache[0] || (_cache[0] = ($event: any) => ($setup.selectFile($event))),
                  type: "file",
                  accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                }, null, 32),
                ($setup.templateFile)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString($setup.templateFile.name), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              class: "button default primary",
              onClick: $setup.uploadTemplate,
              type: "button",
              disabled: !$setup.templateFile
            }, "Upload Lots Template", 8, _hoisted_15)
          ])
        ])
      ]),
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "block-title" }, "Example xlsx Leads Template Settings", -1)),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("a", {
            class: _normalizeClass(["button default primary", { disabled: !$setup.templateLeadsDownloadLink }]),
            href: $setup.templateLeadsDownloadLink,
            target: "_blank"
          }, "Download Leads Template", 10, _hoisted_18)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("button", {
            class: "button default delete",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.deleteTemplate('leads'))),
            disabled: !$setup.templateLeadsDownloadLink
          }, "Delete Leads Template", 8, _hoisted_20)
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("form", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("label", _hoisted_25, [
                _cache[5] || (_cache[5] = _createTextVNode("Select New xlsx Leads Template", -1)),
                _createElementVNode("input", {
                  onChange: _cache[2] || (_cache[2] = ($event: any) => ($setup.selectFile($event, 'leads'))),
                  type: "file",
                  accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                }, null, 32),
                ($setup.templateLeadsFile)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString($setup.templateLeadsFile.name), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("button", {
              class: "button default primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.uploadTemplate('leads'))),
              type: "button",
              disabled: !$setup.templateLeadsFile
            }, "Upload Leads Template", 8, _hoisted_28)
          ])
        ])
      ])
    ])
  ]))
}